import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'
import InputTextSF from '../../../widgets/form/InputTextSF'

const EMIracker2AllocationUpdateModalUI = ({
  context, successMsg, errorList, setErrorList,
  updateMode, submitted, onSubmit, onCancelClick, allocateList,
  allocation, onAllocationChange, allocationError, setAllocationError
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Change Allocation'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >

    <InputSelectSF allocation='select' name='allocation' label='Allocate'
      value={allocation} onChange={onAllocationChange} optionList={allocateList}
      error={allocationError} setError={setAllocationError}
    />
  </ModalFormUI>

export default EMIracker2AllocationUpdateModalUI
